module.exports = __webpack_public_path__ + "static/img/Cardfooter08.1a3a35b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Cardfooter08.png
// module id = Ei1/
// module chunks = 1